import { Input, Form, Card, Row, Col, Typography, Image } from "antd";
import React, { useEffect, useState } from "react";
import BG from "../../assets/images/Login_desktopBG.png";
import { Content } from "antd/lib/layout/layout";
import Logo350 from "../../assets/images/Logo_350.png";
import { useParams } from "react-router-dom";
import { useId24 } from "../../drivers/id24/Id24Provider";
import { RegisterWalkin } from "./services/register-walk-in-service";
import { useForm } from "antd/lib/form/Form";
import { loadAppConfig } from "../../configs/app-config";

export const MainProfile: React.FC = (): React.ReactElement => {
  const { id24Axios } = useId24();
  const apiBaseUrl = id24Axios(loadAppConfig().REACT_APP_API_BASE_URL);
  const { userid } = useParams<{ userid: any }>();
  const [form] = useForm();
  const [dataProfile, setDataProfile] = useState<{
    id: number;
    userId: string;
    numberId: string;
    fullName: string;
    email: string;
    company: string;
    department?: string;
    position: string;
    phone: string;
    qrcodeId: string;
    confirmStatus: boolean;
    registerStatus: boolean;
    registerDate: string;
    agendaId: string;
    createDate: string;
    updateDate: string;
  }>();

  useEffect(() => {
    RegisterWalkin(apiBaseUrl)
      .getProfile(userid)
      .then(
        (
          resultProfile: [
            {
              id: number;
              userId: string;
              numberId: string;
              fullName: string;
              email: string;
              company: string;
              department?: string;
              position: string;
              phone: string;
              qrcodeId: string;
              confirmStatus: boolean;
              registerStatus: boolean;
              registerDate: string;
              agendaId: string;
              createDate: string;
              updateDate: string;
            }
          ]
        ) => {
          setDataProfile(resultProfile[0]);
          form.setFieldValue("cardno", resultProfile[0].numberId);
          form.setFieldValue("fullName", resultProfile[0].fullName);
          form.setFieldValue("company", resultProfile[0].company);
          form.setFieldValue("position", resultProfile[0].position);
          form.setFieldValue("email", resultProfile[0].email);
          form.setFieldValue("phone", resultProfile[0].phone);
        }
      );
  }, [form, userid]);

  return (
    <Row>
      <Col xs={24} md={24} lg={24} className="flex justify-center items-center">
        <Card
          className="w-full border-none bg-cover bg-right bg-no-repeat min-h-screen flex justify-center items-center"
          style={{ backgroundImage: `url(${BG})` }}
        >
          <Content className="pl-0.5 pr-0.5 mx-1 min-h-[80vh] w-[fill-available]">
            <Card className="w-[fill-available] rounded-[20px] shadow-[rgba(0,_0,_0,_0.15)_1.95px_1.95px_2.6px]">
              <div className="flex justify-center mb-2.5">
                <Image src={Logo350} width={"70%"} preview={false} />
              </div>
              <div>
                <Typography className="font-bold text-center mb-7.5">{`Registration Form for check in`}</Typography>
                <Form form={form} layout="vertical" autoComplete="off" className="w-full">
                  <Form.Item label={"Card-No"} name={"cardno"}>
                    <Input placeholder="Text" disabled />
                  </Form.Item>
                  <Form.Item label={"Name-Surname"} name={"fullName"}>
                    <Input placeholder="Text" disabled />
                  </Form.Item>
                  <Form.Item label={"Company"} name={"company"}>
                    <Input placeholder="Text" disabled />
                  </Form.Item>
                  <Form.Item label={"Position"} name={"position"}>
                    <Input placeholder="Text" disabled />
                  </Form.Item>
                  <Form.Item label={"Business Email"} name={"email"}>
                    <Input placeholder="example@email.com" type="email" disabled />
                  </Form.Item>
                  <Form.Item label={"Phone number"} name={"phone"}>
                    <Input placeholder="0XX-XXX-XXXX" disabled />
                  </Form.Item>
                </Form>
              </div>
            </Card>
          </Content>
        </Card>
      </Col>
    </Row>
  );
};
